export default __webpack_public_path__ + "static/media/icon-autochłodnia.e9d4dfc8.svg";